<template>
    <div class="cart-total-card">
        <cart-total v-bind="cartTotalProps"></cart-total>

        <!-- Place Order button -->
        <small class="legal-copy" v-if="page == 'checkout'">By clicking Place order, I agree to the
          <versioned-content-link contentType="TERMS_AND_CONDITIONS">
            H&#8209;E&#8209;B Terms &amp; Conditions
          </versioned-content-link> and acknowledge the
          <versioned-content-link contentType="PRIVACY_POLICY">
              Privacy Policy
          </versioned-content-link>.
        </small>
        <checkout-place-order-button v-if="page == 'checkout'" class="mb-3"></checkout-place-order-button>

        <!-- Go to checkout page button -->
        <proceed-to-checkout-button v-if="page == 'cart'" class="mb-3"></proceed-to-checkout-button>

        <cart-gratuity
            v-if="$store.state.cart.curbsideFulfillmentMode === 'delivery' &&
            this.$router.currentRoute.name.toLowerCase() === 'checkout'"
            :cart-total="$store.state.cart.priceInfo.itemTotal.amount"
            :location="'sidebar'"></cart-gratuity>
        <order-note v-if="page != 'orderconfirmation'"></order-note>
        <promo-code :expanded="cartTotalCardInfo.showPromoCodeInput" class="promo-component" v-if="page != 'orderconfirmation'"></promo-code>
        <div v-if="showDesclaimerText" class="varied-price-disclaimer">
            Prices may vary based on substitutions and final weight of some items.
        </div>

        <div
          class="covid-info__container"
          v-if="$store.state.cart.containsBestAvailableItem && page != 'orderconfirmation'"
          v-html="$store.state.cart.bestAvailableDisclaimer"
        ></div>

        <div class="mb-3" v-show="markupMessage">
          {{ markupMessage }}
        </div>

        <!-- Links user to the order details page -->
        <div class="view-order mt-3" v-if="showViewMyOrder" @click="goToOrderDetailsPage (orderDetailsId)">
            View My Order
        </div>

    </div>
</template>

<script>
import CartPromoCode from './CartPromoCode'
import CartOrderNote from './CartOrderNote'
import CartGratuity from './CartGratuity'
import CartTotal from './CartTotal'
import checkoutPlaceOrderButton from '../checkout/CheckoutPlaceOrderButton'
import checkoutNowButton from '../checkout/CheckoutNowButton'
import VersionedContentLink from '../VersionedContentLink'
import orderDetailsUrl from '../mixins/orderDetailsUrl';

export default {
  name: 'CartTotalCard',
  components: {
    'promo-code': CartPromoCode,
    'order-note': CartOrderNote,
    'cart-total': CartTotal,
    'cart-gratuity': CartGratuity,
    'checkout-place-order-button': checkoutPlaceOrderButton,
    'proceed-to-checkout-button': checkoutNowButton,
    'versioned-content-link': VersionedContentLink
  },
  mixins: [orderDetailsUrl],
  props: {
    cartTotalCardInfo: Object
  },
  data () {
    return {
      showPromoCodeInput: this.cartTotalCardInfo.showPromoCodeInput,
      showTotalSavingsSection: this.cartTotalCardInfo.showTotalSavingsSection,
      showViewMyOrder: this.cartTotalCardInfo.showViewMyOrder,
      showDesclaimerText: this.cartTotalCardInfo.showDesclaimerText,
      loginRoutePath: window.heb.data.user.loginURL,
      isUserLoggedIn: window.heb.data.user.isLoggedIn,
      btnRoutePath: this.cartTotalCardInfo.btnRoutePath,
      submitButtonText: this.cartTotalCardInfo.submitButtonText,
      orderDetailsId: window.heb.data.cart.order.id
    }
  },
  computed: {
    page () {
      return this.$router.currentRoute.name.toLowerCase()
    },
    markupMessage() {
      // Duplicated from NavigationFooter.vue
      // markup should be format XP where x is the markup percent, so we can trim the P to format it as a percent
      if (!this.$store.state.cart.markup || this.$store.state.cart.markup === '0P') {
        return null;
      }
      return `*${this.$store.state.cart.containsBestAvailableItem ? '*' : ''} Online prices may vary from in-store prices.`;
    },
    cartTotalProps () {
      return {
        ...this.cartTotalCardInfo,
        hasMarkup: !!this.markupMessage
      }
    }
  },
  methods: {
    goToOrderDetailsPage (orderId) {
      window.location = this.orderDetailsUrl(orderId);
    // this.$router.push({name: 'OrderHistoryDetails', query: {orderId: orderId}})
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/lib';

.cart-total-card {
    background-color: $color-text-white;
    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.15);
    display: flex;
    flex-direction: column;
    padding: 20px 18px;
    font-size: 14px;
}

.legal-copy {
  padding-bottom: 15px;
}

.view-order {
    display: flex;
    justify-content: center;
    color: $color-link-system;
    font-weight: $font-weight-boldish;
    cursor: pointer;
}

.promo-component {
    margin-bottom: 4px;
}

.item-text {
    color: $color-text-dark;
    font-family: $font-standard-text;
    font-weight: $font-weight-boldish;
    font-size: 14px;
    line-height: 19px;
}

.item-text--red {
    color: $color-text-red;
    font-weight: $font-weight-bold;
}

.varied-price-disclaimer {
  margin-bottom: 1rem;
}

.covid-info__container {
  background: linear-gradient(0deg, rgba(252, 209, 49, 0.05), rgba(252, 209, 49, 0.05)), #FFFFFF;
  /* Pineapple (#FCD131) */
  border: 1px solid #FCD131;
  border-radius: 24px;
  text-align: center;
  box-shadow: 0px 8px 8px 0px rgba(0, 0, 0, 0.05);
  padding: 14px;
  margin-bottom: 1rem;
  display: none;

  @media screen and (min-width: $breakpoint-desktop){
    display: block;
  }
}
</style>

<docs>
    The Vue component for the cart total card.

    ```jsx

        props: {
            cartTotalCardInfo: Object
        }
        <cart-total v-bind:cartTotalCardInfo="cartTotalCardInfo"></cart-total>
    ```

    `cartTotalCardInfo` is displaying content to the user dependent on what page the user is on (Cart page, checkout page, order confirmation page)

</docs>
